import { makeStyles } from '@mui/styles'
import { Theme } from '../../../../UI'

export default makeStyles((theme: Theme) => ({
  error: {
    borderColor: `${theme.palette.error.main} !important`,
  }
}))
